// src/components/ProductsHeroBAnner.js
import React from "react";
import './ProductHeroBanner.css';
import EMR from '../assets/emr-products.png';
import DigitalFootprintProducts from '../assets/digital-footprint-products.png';
import DigitalOutreachProducts from '../assets/digital-outreach-products.png';
import DataAndInsightsProducts from '../assets/data-and-insights-products.png';
import BillingAndPaymentsProducts from '../assets/billing-and-payments-products.png';

const ProductHeroBanner = () => {
    return (
        <section className="product-hero-banner">
            <div className="hero-content">
                <h5 className="hero-subheading">All-in-one solution</h5>
                <h2 className="hero-main-heading">Improve care delivery with Doclivo's comprehensive Ecosystem.</h2>
            </div>
            <div className="icon-container">
                <div className="icon-box">
                    <img src={EMR} alt="EMR Icon" className="icon"></img>
                    <p>EMR</p>
                </div>
                <div className="icon-box">
                    <img src={DigitalFootprintProducts} alt="Digital Footprint Icon" className="icon"></img>
                    <p>Digital Footprint</p>
                </div>
                <div className="icon-box">
                    <img src={DigitalOutreachProducts} alt="Digital Outreach" className="icon"></img>
                    <p>Digital Outreach</p>
                </div>
                <div className="icon-box">
                    <img src={BillingAndPaymentsProducts} alt="Billing & Payments" className="icon"></img>
                    <p>Billing & Payments</p>
                </div>
                <div className="icon-box">
                    <img src={DataAndInsightsProducts} alt="Data & Insights" className="icon"></img>
                    <p>Data & Insights</p>
                </div>
            </div>
        </section>
    );
};

export default ProductHeroBanner;